// src/pages/comercial/components/CriarObjetivosDialogIndividuais.js
import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function CriarObjetivosDialogIndividuais({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Objetivos Individuais</DialogTitle>
      <DialogContent dividers>
        <MDTypography variant="body2">
          (Placeholder) — no passo da API vamos ligar aos endpoints de objetivos por vendedor.
        </MDTypography>
      </DialogContent>
      <DialogActions>
        <MDButton color="info" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
